import React from "react";
import styles from './styles.module.scss';
import TickSvg from "../../components/svg/TickSvg";
import Products from "./Products";
import Try, {TryBtn} from "../../components/Try";

export default function Data() {
  return <>
    <section className={styles.head}>
      <div className={styles.headContent}>
        <div className={styles.title}>
          <h4>烯牛数据·科创数据库</h4>
          <h1>股权资本市场<br />数据全覆盖</h1>
          <Try />
        </div>
        <div className={styles.sticker} style={{marginLeft: "250px"}}><img src="./static-official/images/sticker-data.png" height={463} style={{bottom: "24px"}} alt="科创数据库" /></div>
      </div>
    </section>
    <Cards />
    <Fwxs />
  </>
}

function Cards() {
  return <section className={styles.commonSection0}>
    <div className={styles.cardList}>
      <div className={styles.card}>
        <div>
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="30" height="26"><defs><clipPath id="a"><rect width="30" height="26" rx="0"/></clipPath></defs><g clipPath="url(#a)"><path d="m7.094 8.483 6.576 4.114 7.846-4.287L13.67 0 7.094 8.483Z" fill="#3E8DFF"/><path d="m2.97 13.715-2.971 3.79L13.576 26v-5.628L2.969 13.715Zm10.659 6.602v5.63l16.37-8.64-3.714-3.903-12.656 6.913ZM6.106 9.66l-2.123 2.712 9.652 6.041V14.39L6.106 9.66Zm7.538 4.73v4.022l11.621-6.126-2.66-2.791-8.961 4.895Z" fill="#004EFC" /></g></svg>
            科创企业数据
          </h3>
          <desc>在全量工商库基础上，针对科技企业进行机器+人工的数据精加工，最大程度还原企业业务内容与发展状况，让用户“像投资人一样”了解企业。</desc>
          <ul>
            <li><h4><TickSvg />国家高新技术企业及科技型中小企业</h4></li>
            <li><h4><TickSvg />专精特新小巨人及专精特新中小企业</h4></li>
            <li><h4><TickSvg />私募股权融资企业</h4></li>
            <li><h4><TickSvg />科创企业评分模型</h4></li>
          </ul>
        </div>
        <TryBtn width="100%"/>
      </div>
      <div className={styles.card}>
        <div>
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="33" height="25"><defs><clipPath id="a"><rect width="33" height="25" rx="0"/></clipPath></defs><g clipPath="url(#a)"><path d="M22.774 6.169H10.353C9.699 6.167 9.17 5.65 9.17 5.016V1.142C9.176.512 9.703.002 10.353 0h12.421c.654.002 1.183.518 1.183 1.153v3.873c-.003.632-.532 1.144-1.183 1.143Zm0 9.41H10.353c-.654-.001-1.183-.517-1.183-1.152v-3.874c0-.635.529-1.15 1.183-1.152h12.421c.654.002 1.183.517 1.183 1.152v3.872c.007.639-.525 1.16-1.183 1.16v-.005Zm0 9.412H10.353c-.654-.002-1.183-.517-1.183-1.152v-3.874c0-.635.529-1.15 1.183-1.153h12.421c.654.003 1.183.518 1.183 1.153v3.872c.004.308-.12.604-.342.823a1.193 1.193 0 0 1-.84.34v-.009Z" fill="#004EFC"/><path d="M6.858 24.906H5.57C2.476 24.846 0 22.38 0 19.359c0-3.02 2.476-5.486 5.57-5.546h1.288c.656.001 1.187.518 1.187 1.155 0 .636-.53 1.153-1.187 1.154H5.57c-1.833 0-3.32 1.45-3.32 3.24 0 1.79 1.487 3.24 3.32 3.24h1.288c.656 0 1.188.517 1.188 1.154 0 .637-.532 1.154-1.188 1.154v-.004ZM27.313 15.671h-1.288c-.656 0-1.188-.516-1.188-1.154 0-.637.532-1.154 1.188-1.154h1.288c1.835 0 3.322-1.451 3.322-3.242s-1.487-3.244-3.322-3.244h-1.288c-.656 0-1.188-.517-1.188-1.154 0-.637.532-1.154 1.188-1.154h1.288c3.14.023 5.672 2.501 5.672 5.55 0 3.05-2.533 5.528-5.672 5.55v.002Z" fill="#3E8DFF"/></g></svg>
            科创产业链与最新赛道
          </h3>
          <desc>4000条产业链聚焦新质生产力与战略新兴产业，通过企业、投融资事件、投资机构、政府引导基金等多重维度，实时展现高精尖产业全貌，帮助用户快速掌握产业发展脉搏。</desc>
          <ul>
            <li><h4><TickSvg />企业动态标签画像</h4></li>
            <li><h4><TickSvg />最新赛道与行业图谱</h4></li>
            <li><h4><TickSvg />新质生产力与战略新兴产业链</h4></li>
          </ul>
        </div>
        <TryBtn width="100%"/>
      </div>
      <div className={styles.card}>
        <div>
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="27" height="25"><defs><clipPath id="a"><rect width="27" height="25" rx="0"/></clipPath></defs><g clipPath="url(#a)"><path d="M0 9.976c0-1.038.863-1.879 1.928-1.878h23.143c1.065 0 1.929.84 1.929 1.878v13.146C27 24.159 26.136 25 25.071 25H1.928C.863 25 0 24.16 0 23.122V9.976Z" fill="#3E8DFF"/><path d="M4.821 4.623c0-.742.45-1.415 1.146-1.716L11.935.324a3.951 3.951 0 0 1 3.133 0l5.967 2.583a1.876 1.876 0 0 1 1.145 1.716v18.5c0 1.036-.863 1.877-1.928 1.877H6.75c-1.065 0-1.929-.84-1.929-1.878v-18.5Z" fill="#004EFC"/><path d="M9.644 9.037a.952.952 0 0 0-.965-.94.952.952 0 0 0-.964.94v.939c0 .518.432.939.964.939.533 0 .965-.42.965-.94v-.938Zm4.82 0a.952.952 0 0 0-.963-.94.952.952 0 0 0-.965.94v.939c0 .518.432.939.965.939.532 0 .964-.42.964-.94v-.938Zm4.822 0a.951.951 0 0 0-.964-.957.951.951 0 0 0-.964.957v.939c.01.511.439.92.964.92.525 0 .954-.409.964-.92v-.94Zm-9.642 4.695a.952.952 0 0 0-.965-.94.952.952 0 0 0-.964.94v.939c0 .519.432.94.964.94.533 0 .965-.421.965-.94v-.94Zm4.82 0a.952.952 0 0 0-.963-.94.952.952 0 0 0-.965.94v.939c0 .519.432.94.965.94.532 0 .964-.421.964-.94v-.94Zm4.822 0a.951.951 0 0 0-.964-.957.951.951 0 0 0-.964.957v.939c.01.512.439.921.964.921.525 0 .954-.41.964-.921v-.94Zm-9.642 5.634a.952.952 0 0 0-.963.94v1.877c0 .519.432.94.964.94h7.713c.532 0 .964-.421.964-.94v-1.878a.952.952 0 0 0-.964-.939H9.644Z" fill="#FFF"/></g></svg>
            创投机构数据
          </h3>
          <desc>解析创投机构品牌—私募基金管理人—基金关联关系，实时分析投资机构战绩风格、投资与退出、基金业绩等数据。</desc>
          <ul>
            <li><h4><TickSvg />机构品牌</h4></li>
            <li><h4><TickSvg />备案私募股权、创投基金管理人及基金</h4></li>
            <li><h4><TickSvg />上市公司与CVC对外投资</h4></li>
            <li><h4><TickSvg />基金回报数据测算</h4></li>
          </ul>
        </div>
        <TryBtn width="100%"/>
      </div>
      <div className={styles.card}>
        <div>
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="26" height="25"><defs><clipPath id="a"><rect width="26" height="25" rx="0"/></clipPath></defs><g clipPath="url(#a)"><path d="M24.725 22.103H22.93v-1.475H3.068v1.475H1.33v1.42H0V25h26v-1.478h-1.275v-1.419ZM7.326 19.434v-7.386h.869v-.97c0-.594-.49-1.075-1.096-1.075H3.267c-.605 0-1.095.482-1.095 1.075v.97H3.1v7.386h4.228Zm15.575 0v-7.386h.927v-.969c0-.593-.49-1.074-1.094-1.074h-3.83c-.604 0-1.095.48-1.094 1.074v.97h.926v7.385H22.9Zm-7.816 0v-7.386h.925v-.97c0-.593-.49-1.075-1.094-1.075h-3.83c-.606 0-1.096.482-1.096 1.075v.97h.868v7.386h4.226Zm9.672-13.327L13.942.238a1.974 1.974 0 0 0-1.881 0L1.244 6.108a2.141 2.141 0 0 0-1.13 1.877v.658h25.77v-.658c0-.78-.432-1.499-1.127-1.878Zm-7.437-.515a.231.231 0 0 1-.227.173H8.9a.234.234 0 0 1-.229-.172.229.229 0 0 1 .114-.26l3.268-1.776a1.981 1.981 0 0 1 1.885 0l3.267 1.776c.094.05.142.157.115.26h.001Z" fill="#004EFC" /><path d="M7.326 19.434v-7.385h.869v-.971c0-.594-.49-1.075-1.096-1.075H3.267c-.605 0-1.096.482-1.095 1.075v.97h.927v7.386h4.227Zm15.575 0v-7.385h.926v-.97c0-.593-.489-1.074-1.094-1.074h-3.829c-.605 0-1.095.48-1.095 1.074v.97h.927v7.385H22.9Zm-7.817 0v-7.385h.926v-.971c0-.593-.49-1.075-1.094-1.075h-3.831c-.605 0-1.095.482-1.095 1.075v.97h.868v7.386h4.226Z" fill="#3E8DFF" /></g></svg>
            LP与政府引导基金数据
          </h3>
          <desc>从一级市场资金源头一键穿透LP-GP-企业股权链，实时观察资金流向，适用于募资、股权招商、返投分析等多种场景。</desc>
          <ul>
            <li><h4><TickSvg />政府引导基金</h4></li>
            <li><h4><TickSvg />市场化母基金</h4></li>
            <li><h4><TickSvg />金融机构、上市公司LP</h4></li>
            <li><h4><TickSvg />基金及底层资产实时追踪</h4></li>
          </ul>
        </div>
        <TryBtn width="100%"/>
      </div>
    </div>
  </section>
}

function Fwxs() {
  return <section className={styles.commonSection0} style={{padding: "60px 0"}}>
    <h2>服务形式</h2>
    <Products />
  </section>
}
